import React, { memo, useMemo, useState, Fragment } from 'react';
import { Proposal } from '../types';
import { BlockContainer } from '../BlockContainer';
import './index.scss';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import classNames from 'classnames';
import { defineBlockAdvanceForm } from '../Common/AdvanceSettings';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useConfigureBlock } from '@modules/proposal/hooks';
import { PDFBlockSettings } from './PDFBlockSettings';
import { Container } from 'reactstrap';
import { UploadResponse } from '@business/entities/common';

function definePDFBlockForm() {
  return formGroup({
    file: formControl<UploadResponse>({}),
    height: formControl<number>({ initialValue: 800, label: 'Height' }),
    advance: defineBlockAdvanceForm(),
  });
}

export type PDFWidgetFormData = FormDataType<typeof definePDFBlockForm>;
export type PDFWidgetForm = ReturnType<typeof definePDFBlockForm>;

export enum PDFBlockVariation {
  pdf = 'pdf',
}

export const PDFBlock = memo((props: Proposal.BlockProps<PDFBlockVariation>) => {
  const { variation } = props;
  const form = useMemo(definePDFBlockForm, []);
  const formValue = useNonNilObservable(form.value$);

  useConfigureBlock({
    props,
    form,
    contentComponent: PDFBlockSettings,
    contentProps: { form },
  });

  const content = useMemo(() => {
    if (!formValue.file) return null;
    return (
      <Container>
        <object data={formValue.file.fileUrl} type="application/pdf" width="100%" height={formValue.height}>
          <p>
            <a href={formValue.file.fileUrl}>PDF</a>
          </p>
        </object>
      </Container>
    );
  }, [formValue]);

  return (
    <BlockContainer className={classNames('d-flex flex-fill', 'block-embed', variation)} advanceForm={formValue.advance}>
      {content}
    </BlockContainer>
  );
});
